import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useSalesHistoryConfig } from '../hooks/SalesHistoryConfigContext';

const ModalPopup = ({ show, onHide, message, callback }) => {
    const salesHistoryConfig = useSalesHistoryConfig();
    const localizedFromSalesHistoryConfig = salesHistoryConfig.labels;

    return (
        <Modal
            show={show}
            onHide={onHide}
            backdrop="static"
            keyboard={false}
            centered
            animation={false}
        >
            <div className="button-wrapper">
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
            </div>

            <Modal.Body>{message}</Modal.Body>

            <Modal.Footer>
                <div className="button-wrapper">
                    <Button
                        variant="secondary"
                        className="button button-secondary"
                        onClick={onHide}
                    >
                        {localizedFromSalesHistoryConfig.ReturnConfirmationNo}
                    </Button>
                </div>

                <div className="button-wrapper">
                    <Button variant="primary" className="button" onClick={callback}>
                        {localizedFromSalesHistoryConfig.ReturnConfirmationYes}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalPopup;
